import { useCases as bambaUseCases } from './useCases/Bamba';
import { useCases as chowboticsUseCases } from './useCases/Chowbotics';
import { useCases as dvsUseCases } from './useCases/DVS';
import { useCases as kidiupUseCases } from './useCases/KidiUp';
import { useCases as thbUseCases } from './useCases/The Helper Bees';
import { useCases as clsUseCases } from './useCases/CLS';
import { UseCaseWrapperType } from '../../Types/Portfolio/UseCaseWrapperType';

export const useCases: UseCaseWrapperType[] = [...kidiupUseCases, ...thbUseCases, ...chowboticsUseCases, ...bambaUseCases, ...clsUseCases, ...dvsUseCases];
